// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectConservatoryPorcheQueryResult, selectConservatoryPorchesPageLoading, selectConservatoryPorchesShowInitWaitingMessage} from '../_selectors/conservatory-porche.selectors';

export class ConservatoryPorchesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectConservatoryPorchesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectConservatoryPorchesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectConservatoryPorcheQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
